export default {
  // 日期选择器
  rangeSeparator: "至",
  startDate: "开始日期",
  endDate: "结束日期",

  // 搜索
  searchTxHash: "搜索交易哈希",

  // 按钮
  reset: "重置",
  query: "查询",

  // 数据统计
  totalData: "共计",
  dataUnit: "条数据",

  // 消息提示
  alreadyCurrentPage: "已经是当前地址详情页!",
};
